export default "__VITE_ASSET__nskvc5IP__"